import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-read-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "card-read__turn-around mb-5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "qr_code_scanner", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "360", -1)
const _hoisted_5 = {
  key: 1,
  class: "title is-6 card-read__hint mt-5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Let your connection scan this code", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flip-card-inner" }
const _hoisted_9 = { class: "flip-card-front card" }
const _hoisted_10 = {
  class: "card-content",
  "data-card-content": ""
}
const _hoisted_11 = { class: "card-content__header" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 0,
  class: "subtitle is-6"
}
const _hoisted_14 = { class: "title is-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "content your-card__content" }
const _hoisted_17 = {
  key: 0,
  class: "card-data-field"
}
const _hoisted_18 = { class: "card-data-field__value" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "360", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "flip-card-back card" }
const _hoisted_24 = {
  class: "card-content",
  "data-card-content": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", null, "Click the card to turn to the " + _toDisplayString(_ctx.frontVisibilityIs ? 'Qr code' : 'details'), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.frontVisibilityIs && !_ctx.readOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.cardData)
      ? (_openBlock(), _createElementBlock("article", {
          key: 2,
          class: _normalizeClass(["flip-card", { 'flip': !_ctx.frontVisibilityIs, 'read-only': _ctx.readOnly }]),
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cardHoveredStateIs = true)),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cardHoveredStateIs = false)),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.readOnly ? _ctx.frontVisibilityIs = !_ctx.frontVisibilityIs : null))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("header", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.company)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.company), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.fullName), 1)
                  ]),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardData, (cardDataField, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                      (_ctx.visibleField(cardDataField, key))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(cardDataField), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                (!_ctx.readOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "card-content__button right top",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editCard && _ctx.editCard(...args)))
                    }, _hoisted_20))
                  : _createCommentVNode("", true),
                (!_ctx.readOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["card-content__button right bottom", {'hovered': _ctx.cardHoveredStateIs}])
                    }, _hoisted_22, 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_QrcodeVue, {
                  value: _ctx.qrCodeString,
                  size: 120
                }, null, 8, ["value"])
              ])
            ])
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}